import React, { useState, useEffect } from 'react'
import AppLayout from '../../../../../layout/components/AppLayout'
import { useAppData } from '../../../../../context/AppDataContext';
import TaskForm from '../components/TaskForm';
import TaskListView from '../components/TaskListView';
import { useAuth } from '../../../../../context/AuthContext';
import TaskFilterToolBar from '../hook/TaskFilterToolBar';
import { useTaskFilters } from '../hook/useTaskFilter';
import TaskActivityList from '../components/TaskActivityList';
import TaskCalendarView from '../components/TaskCalendarView';
import { CalendarMonth, TableChart, ViewStream } from '@mui/icons-material';
import TaskCardListView from '../components/TaskCardListView';
import { Link } from 'react-router-dom';

function TaskArchivedPage() {
    const { archivedTaskList,getArchivedTaskList,getTaskList } = useAppData();

    const [selectedView,setSelectedView] = useState("card")


    const archivedCallBack = () =>{
        getArchivedTaskList();
        getTaskList();
    }

    useEffect(() => getArchivedTaskList(), []);

    return (
        <AppLayout>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-md-8'>
                        <div className='row align-items-center mb-0'>
                            <div className='col-6'>
                                <div className="btn-group" role="group">
                                    <button type="button" className={selectedView === "card" ? "btn btn-primary" : "btn btn-outline-primary"} onClick={()=>setSelectedView("card")}  ><ViewStream/> </button>
                                    <button type="button" className={selectedView === "tabular" ? "btn btn-primary" : "btn btn-outline-primary"} onClick={()=>setSelectedView("tabular")}  ><TableChart/> </button>
                                    <button type="button" className={selectedView === "calendar" ? "btn btn-primary" : "btn btn-outline-primary"} onClick={()=>setSelectedView("calendar")}  ><CalendarMonth/></button>
                                </div>
                                <Link to="/task/dashboard" className='ms-2 btn btn-outline-success'>Show Active List</Link>
                            </div>
                        </div>
                        
                        <div className='row'>
                            <div className='col-md-12' style={{maxHeight:"80vh", overflow:"scroll" }}>
                                {selectedView === "tabular" && <TaskListView taskList={archivedTaskList} callBack={archivedCallBack} /> }
                                {selectedView === "card" && <TaskCardListView taskList={archivedTaskList} callBack={archivedCallBack} /> }
                                {selectedView === "calendar" && <TaskCalendarView taskList={archivedTaskList} callBack={archivedCallBack} /> }
                            </div>
                        </div>
                        
                    </div>
                    
                </div>
            </div>
        </AppLayout>
    );
}

export default TaskArchivedPage